import { apiClient } from '@/utils/api-client';
import type { DrawdownMatrix } from '@/types/drawdown';

export class DrawdownMatrixService {
  /** Every investor in a fund against every capital call it has issued */
  static async getMatrix(fundId: string): Promise<DrawdownMatrix> {
    return apiClient.get<DrawdownMatrix>(`/funds/${fundId}/drawdowns/matrix`);
  }
}
